import { render, staticRenderFns } from "./Copyright.vue?vue&type=template&id=8f8e0afe&scoped=true&"
import script from "./Copyright.vue?vue&type=script&lang=ts&"
export * from "./Copyright.vue?vue&type=script&lang=ts&"
import style0 from "./Copyright.vue?vue&type=style&index=0&id=8f8e0afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8e0afe",
  null
  
)

export default component.exports